import {useGetCoverageConfirmationTransitionsQuery} from "../../redux/api/coverageConfirmationApiSlice";
import {CalendarOutlined, RightOutlined} from "@ant-design/icons";
import React, {useState} from "react";
import {Col, Divider, Modal, Row, Typography} from "antd";
import {stateToColors} from "../../utils/formatters";
import dayjs from "dayjs";
import {CoverageTransitionHistory} from "../../types/negotiations";
import {getSubmissionStateLabel} from "./SelectSurveyPageCard";

const {Title, Paragraph} = Typography

export default function CoverageHistoryModalButton({coverageID} : {coverageID: string}) {

    const [
    isHistoryModalOpen,
    setIsHistoryModalOpen
  ] = useState(false);

    const {data: historyData} = useGetCoverageConfirmationTransitionsQuery(coverageID)

    return <>
        <Modal
      title="Storico della submission"
      centered
      open={isHistoryModalOpen}
      onCancel={()=> setIsHistoryModalOpen(false)}
      footer={null}
    >

      <Row>

        {historyData && historyData?.map((coverageStatus: CoverageTransitionHistory, idx: number) => {
            return (
              <Col key={idx} span={24}>
                <Row align='middle' justify='space-between'>
                  <Col>
                    <Row justify='start' align='middle' gutter={8}>
                      <Col style={{
                        width: '6px',
                        height: '6px',
                        backgroundColor: "black",
                        borderRadius: '50px',
                        padding: 0
                      }}>

                      </Col>
                      <Col>
                        <Paragraph>{getSubmissionStateLabel(coverageStatus.state_cc_to)}</Paragraph>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row gutter={8}>
                      <Col>
                        <CalendarOutlined/>
                      </Col>
                      <Col>
                        <Paragraph>{dayjs(coverageStatus.date_creation).format('DD/MM/YYYY HH:mm')}</Paragraph>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div style={{marginLeft: '11px'}}>
                  {coverageStatus.reason_text && <Row style={{marginTop: '0.1rem'}}>
                    <Paragraph style={{fontSize: '12px'}}> <span
                      style={{fontWeight: 'bold'}}>Motivazioni:</span> {coverageStatus.reason_text}
                    </Paragraph>
                  </Row>}
                  {coverageStatus.notes && <Row>
                    <Paragraph style={{fontSize: '12px'}}> <span
                      style={{fontWeight: 'bold'}}>Commento:</span> {coverageStatus.notes}
                    </Paragraph>
                  </Row>}
                  {coverageStatus.responsible_user && <Row>
                    <Paragraph style={{fontSize: '12px'}}> <span
                      style={{fontWeight: 'bold'}}>Referral:</span> {coverageStatus.responsible_user}
                    </Paragraph>
                  </Row>}
                  {coverageStatus.user_creation && <Row>
                    <Paragraph style={{fontSize: '12px'}}> <span
                      style={{fontWeight: 'bold'}}>Autore:</span> {coverageStatus.user_creation}
                    </Paragraph>
                  </Row>}
                </div>
                <Divider/>
              </Col>
            )
          }
        ).reverse()}

      </Row>


    </Modal>
        <div
        className={'btn-text'}
        onClick={() => setIsHistoryModalOpen(true)}>
        <p style={{color: 'inherit !important'}}>
          Storico
        </p>
        <RightOutlined style={{marginLeft: '4px'}}/>
      </div>
    </>
}